module.exports = __webpack_public_path__ + "media/images/countdown__background-6ae960d4a755575e30d9b266993f6140.jpg";